// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatMessages_wrapper__3cq4J","noMessage":"ChatMessages_noMessage__1-G-V"};